export function checkName(_, value) {
  let isValid = true;
  let regex = new RegExp(/^[a-zA-Z0-9-_]+$/);
  if (value) {
    isValid = regex.test(value);
  }
  return isValid ? Promise.resolve() : Promise.reject();
}
